import { render, staticRenderFns } from "./IndicadorGastosVentas.vue?vue&type=template&id=133d72c2&"
import script from "./IndicadorGastosVentas.vue?vue&type=script&lang=js&"
export * from "./IndicadorGastosVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports